import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '../components/Typography';
import { Button } from '../components/input';
import { LandingLayout } from '../components/layout';

const headline = 'Building software that works for you';
const subline =
    'Mnemetic helps startups and growing teams design, build and launch custom software and AI-powered products, from first prototype to production.';

export default function ProductHero() {
    return (
        <LandingLayout
            sxBackground={{
                backgroundColor: 'primary.main',
            }}
        >
            <Box
                component="img"
                src="/logo.svg"
                alt="Mnemetic logo"
                sx={{ width: { xs: 96, sm: 128 }, height: { xs: 96, sm: 128 }, mb: 4 }}
            />
            <Typography
                color="inherit"
                align="center"
                variant="h2"
                marked="center"
                sx={{ fontSize: { xs: 36, sm: 48, md: 60 }, maxWidth: 900 }}
            >
                {headline}
            </Typography>
            <Typography
                color="text.secondary"
                align="center"
                variant="h5"
                sx={{ mt: 4, maxWidth: 680 }}
            >
                {subline}
            </Typography>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                sx={{ mt: { xs: 6, sm: 8 }, width: { xs: '100%', sm: 'auto' } }}
            >
                <Button
                    color="secondary"
                    variant="contained"
                    size="large"
                    component="a"
                    href="#contact"
                    sx={{ color: 'primary.main', minWidth: 200 }}
                >
                    Book a call
                </Button>
                <Button
                    color="secondary"
                    variant="outlined"
                    size="large"
                    component="a"
                    href="#services"
                    sx={{ minWidth: 200 }}
                >
                    See services
                </Button>
            </Stack>
        </LandingLayout>
    );
}
